import twemoji from 'twemoji'

const options = {
  className: 'emoji',
  folder: 'twemoji',
  ext: '.svg',
  base: 'https://cdn.inteliwise.com/icons/',
}

export default (text: string) => {
  return twemoji.parse(text, options)
  // po co tu był kasowany alt? WCAG?
  // .replace(/draggable="false" alt=".*?"/g, 'draggable="false"')
}
